import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { round } from 'lodash';
import KpiTable from '../../commons/KpiTable';
import Icon from '../../../../core/layout/Icon';
import Tag from '../../../../core/layout/Tag';

const LearningCorrectAnswersRateTable = (props) => (
  <KpiTable
    title="Correct answers rate"
    description="The number represents the average between each course correct answers rate. The calculate course correct answers rate is the comparing between the number of correct answers of the course Bonus Test and the previous Bonus Test (not necessarily the previous course Bonus Test)."
    nameColumnLabel="Bonus Test source course"
    firstDataColumnLabel="Rate"
    firstDataColumnPath="rate"
    loading={props.loading}
    values={props.values}
    formatter={props.formatter}
    feedbackColorRender={props.feedbackColorRender}
    additionalColumns={[
      {
        label: 'Correct Answer before/now',
        path: 'extra.correctAnswersBefore',
        render: (text, record) => (
          <span>
            <Tag>{round(record.extra?.correctAnswersBefore)}</Tag>
            <Icon name="arrow-right" style={{ marginRight: 8 }} />
            <Tag>{round(record.extra?.correctAnswers)}</Tag>
          </span>
        ),
      },
      {
        label: 'Studied Hours',
        path: 'extra.averageStudiedHours',
        render: (value) => `${moment.duration(value, 'hours').format('hh:mm')} hrs`,
      },
      {
        label: 'Number of tests',
        path: 'total',
      },
    ]}
  />
);

LearningCorrectAnswersRateTable.propTypes = {
  loading: PropTypes.bool.isRequired,
  values: PropTypes.array.isRequired,
  formatter: PropTypes.func.isRequired,
  feedbackColorRender: PropTypes.func.isRequired,
};

export default LearningCorrectAnswersRateTable;
